import styled from 'styled-components';

export const AccountContainerStyle = styled.div<{ isLoading: boolean }>`
  width: auto;
  height: 40px;
  cursor: ${props => (props.isLoading ? 'default' : 'pointer')};
`;
